import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    querys: {},
    arr: [],
    showChoicePopup: false,
    addBankCardId: '' // 添加银行卡id
  },
  mutations: {
    SET_QUERYS(state, val) {
      state.querys = val
    },
    SET_ARR(state, val) {
      state.arr = val
    },
    SET_SHOW_CHOICE_POPUP(state, val) {
      state.showChoicePopup = val
    },
    SET_ADD_BANK_CARD_ID(state, val) {
      state.addBankCardId = val
    }
  },
  actions: {
    SET_QUERYS({ commit }, val) {
      commit('SET_QUERYS', val)
    },
    SET_ARR({ commit }, val) {
      commit('SET_ARR', val)
    },
    SET_SHOW_CHOICE_POPUP({ commit }, val) {
      commit('SET_SHOW_CHOICE_POPUP', val)
    },
    SET_ADD_BANK_CARD_ID({ commit }, val) {
      commit('SET_ADD_BANK_CARD_ID', val)
    }
  },
  modules: {}
})
